import type { YouthContentDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/content';
import ViewHippoInformationModal from '../../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import type { TableInformation } from '../../../../config/flavourConfig';

const getYouthContentInsuranceSumsCoverableDetailsConfig = (
    youthCoverable: YouthContentDTO
): TableInformation => {
    return {
        title: 'Forsikringssummer',
        rowsInformation: [
            {
                name: 'Indbo',
                fieldValue: youthCoverable.homeYouthContentSum,
                labelType: 'modalLink',
                valueType: 'amount',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-YOUTH-HIGHLIGHTED-TEXT-MODAL-CONTENT-TITLE',
                        description: 'DSS-CON-YOUTH-HIGHLIGHTED-TEXT-MODAL-CONTENT-DESCRIPTION'
                    }
                }
            },
            {
                name: 'Guld, sølv, smykker mv.',
                fieldValue: youthCoverable.homeYouthValuables,
                labelType: 'modalLink',
                valueType: 'amount',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-YOUTH-HIGHLIGHTED-TEXT-MODAL-GOLD-SILVER-JEWELRY-TITLE',
                        description:
                            'DSS-CON-YOUTH-HIGHLIGHTED-TEXT-MODAL-GOLD-SILVER-JEWELRY-DESCRIPTION'
                    }
                }
            },
            {
                name: 'Cykler (pr. cykel)',
                fieldValue: youthCoverable.bicycleSum,
                hidden: !youthCoverable.bicycleSum,
                labelType: 'modalLink',
                valueType: 'amount',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-HIGHLIGHTED-TEXT-MODAL-BICYCLES-TITLE',
                        description: 'DSS-CON-HIGHLIGHTED-TEXT-MODAL-BICYCLES-DESCRIPTION'
                    }
                }
            }
        ]
    };
};

export { getYouthContentInsuranceSumsCoverableDetailsConfig };
